import { render } from "./loader.vue?vue&type=template&id=aba90f26"
const script = {}

import "./loader.vue?vue&type=style&index=0&id=aba90f26&lang=scss"

import exportComponent from "/home/eymekkjd/infos-projet.app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__